export default __webpack_public_path__ + "static/media/myadventure.73198606.png";